import React from "react";
import { Routes, Route, Link as RouterLink, Navigate } from "react-router-dom";
import { Box, AppBar, Toolbar, Typography, Button, Stack } from "@mui/material";
import { useAuth } from "./AuthContext";
import GalleryList from "./galleries/GalleryList";
import GalleryEdit from "./galleries/GalleryEdit";
import Submissions from "./submissions/Submissions";
import ContentEditor from "./content/ContentEditor";
import PartnerLogos from "./partners/PartnerLogos";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <Box>
      <AppBar position="static">
        <Toolbar sx={{ gap: 2 }}>
          <Typography variant="h6" sx={{ flexGrow: 0, mr: 3 }}>Swan Admin</Typography>
          <Stack direction="row" spacing={1} sx={{ flexGrow: 1 }}>
            <Button color="inherit" component={RouterLink} to="/admin">Galleries</Button>
            <Button color="inherit" component={RouterLink} to="/admin/submissions">Submissions</Button>
            <Button color="inherit" component={RouterLink} to="/admin/content">Content</Button>
            <Button color="inherit" component={RouterLink} to="/admin/partners">Partners</Button>
          </Stack>
          <Typography variant="body2" sx={{ mr: 2 }}>{user?.Email}</Typography>
          <Button color="inherit" onClick={logout}>Logout</Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 3 }}>
        <Routes>
          <Route index element={<GalleryList />} />
          <Route path="galleries/:id" element={<GalleryEdit />} />
          <Route path="submissions" element={<Submissions />} />
          <Route path="content" element={<ContentEditor />} />
          <Route path="partners" element={<PartnerLogos />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </Box>
    </Box>
  );
}
